import React, { useEffect, useState } from "react";
import { Grid, useTheme } from "@material-ui/core";
import moment from "moment-jalaali";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import HomeService from "Services/http/endpoints/home/HomeService";
import DatePickerComponent from "Components/DatePickerComponent/DatePickerComponent";
import { useSetState } from "Helpers/Hooks";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import * as Icons from "react-bootstrap-icons";
import showNotify from "Helpers/Notify";
import { getLocaleDate } from "Helpers/GetLocaleDate";

export default function SearchComponent({ backSearchData }) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(moment().startOf('jMonth'));
  const [toDate, setToDate] = useState(moment());
  const [controls, setControls] = useSetState({
    state: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
  });

  useEffect(() => {
    (async () => {
      setLoading(true);
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        IsAdminP: true,
      };
      const response = await HomeService.intervalBar(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const selectItems = data.map((items) => {
          return {
            value: items.Id,
            label: items.Name,
            ...items,
          };
        });
        setControls({
          state: {
            selectItems,
            value: selectItems[0],
          },
        });
      }
      setLoading(false);
    })();
  }, []);

  const handleFromDate = (value) => {
    setFromDate(value);
  };

  const handleToDate = (value) => {
    setToDate(value);
  };

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const doFilter = () => {
    if(fromDate > toDate) {
      showNotify({ text: t("checkDate"), customClass: "error" });
    } else {
      backSearchData({
        Date: `${getLocaleDate(fromDate, direction)}-${getLocaleDate(toDate, direction)}`,
        Interval: +controls.state.value.value,
      });
    }
  };

  return (
    <>
      <Grid container spacing={2} className="my-1">
        <BackDropLoading loading={loading} />
        <Grid item lg={2} md={3} sm={6} xs={12}>
          <DatePickerComponent
            label={t("fromDate")}
            value={fromDate}
            onChange={handleFromDate}
          />
        </Grid>
        <Grid item lg={2} md={3} sm={6} xs={12}>
          <DatePickerComponent
            label={t("toDate")}
            value={toDate}
            onChange={handleToDate}
          />
        </Grid>
        <Grid item lg={2} md={3} sm={6} xs={12}>
          <MuiAutoComplete
            autoSelect={true}
            loading={loading}
            options={controls.state.selectItems}
            label={<Translator id={"period"} />}
            value={controls.state.value}
            id={"state"}
            onChange={autoCompleteHandler}
          />
        </Grid>
        <Grid item lg={2} md={3} sm={6} xs={12} className="margin-top-button no-sm-effect">
          <MuiButton
            color="secondary"
            onClick={doFilter}
            title={<Translator id="doFilter" />}
            innerIcon={<Icons.Funnel />}
            className="w-100"
          />
        </Grid>
      </Grid>
    </>
  );
}
